import { z } from "zod";

export const WeatherSchema = z.object({
  temperature: z.number(),
  icon: z.string(),
});

export type Weather = z.TypeOf<typeof WeatherSchema>;
